<template>
    <el-dialog
    title="菜单目录"
    :visible.sync="centerDialogVisible"
    @close="cancel"
  >
    <div style="margin-bottom:22px">
      <span class="title">类型</span>
      <el-radio-group v-model="choose" @change="radioChange">
        <el-radio :label="3">导航</el-radio>
        <el-radio :label="4">菜单</el-radio>
        <el-radio :label="5" :disabled="hide">首页</el-radio>
      </el-radio-group>
    </div>
    <el-form ref="submitData" :model="submitData" label-width="120px" :rules="rules">
      <el-form-item v-if="!flag" label="选择子系统" prop="appId">
        <el-select v-model="submitData.appId" placeholder="请选择子系统" @change="getContents">
          <el-option v-for="item in systemList" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item v-if="flag" label="选择子系统">
        <span>{{ name }}</span>
      </el-form-item>
      <el-form-item v-if="choose=='4'" label="父节点"  prop="parentId"> 
       <div
   
       id="custom-tree"
       v-for='(items, index) in data'
       :key="index"
     >
       <div class="group-item">
         <div
           class="active-group"
          
           @click.stop="handleNodeClick(items,$event,true)"
         >
          <img
             class="file"
             src="@/assets/icon.png"
           />
           <div class="title-group">
               <div class="lable-text"  v-model="submitData.parentId">{{items.name}}</div>
             
             </div>
         </div>
        
       </div>
     </div>
      </el-form-item>
      <el-form-item v-if="choose=='3'" label="导航名称" prop="name">
        <el-input v-model="submitData.name" />
      </el-form-item>
      <el-form-item v-if="choose=='4'" label="菜单名称" prop="name">
        <el-input v-model="submitData.name" />
      </el-form-item>

      <el-form-item v-if="choose=='5'" label="首页名称" prop="name">
        <el-input v-model="submitData.name" />
      </el-form-item>
      <el-form-item label="排序号" prop="sort">
        <el-input v-model="submitData.sort" />
      </el-form-item>
      <el-form-item label="path" prop="path">
        <el-input v-model="submitData.path" />
      </el-form-item>
      <el-form-item label="访问地址" prop="url">
        <el-input v-model="submitData.url" />
      </el-form-item>
      <el-form-item label="icon" prop="icon">
        <el-input v-model="submitData.icon" />
      </el-form-item>

    </el-form>
    <span
    slot="footer"
    class="dialog-footer"
  >
  <el-button @click="cancel" style="margin-right:8px">取消</el-button>
  <el-button type="primary"  @click="onSubmit('submitData')">确认</el-button>
  </span>
</el-dialog>
</template>
<script>
import { getSystem, createMenu, permissionsList, systemDetail, menuType } from '@/api/system'
import { validateTwenty, lengthFifty, lengthTen, validateTenNumber,validateParentId } from '@/api/validate'
import Setting from '@/settings'
const {
  apiDomain
} = Setting
import jq from 'jquery'
export default {
  props: ['clickType', 'sysId', 'parentId'],
  data() {
    return {
      submitData: {
        appId: "",
        name: '',
        sort: '',
        path: '',
        icon: '',
        url: '',
        parentId:null
      },
      centerDialogVisible:true,
      rules: {
        name: [{
          required: true,
          validator: validateTwenty,
          trigger: 'change'
        }],
        appId: [{
          required: true,
          message: '请选择子系统',
          trigger: 'change'
        }],
        sort: [{
          required: true,
          validator: validateTenNumber,
          trigger: 'change'
        }],
        path: [{
          required: true,
          validator: lengthFifty,
          trigger: 'change'
        }],
        url: [{
          required: true,
          validator: lengthFifty,
          trigger: 'change'
        }],
        icon: [{
          required: true,
          validator: lengthFifty,
          trigger: 'change'
        }],
        parentId:[{
          required:true,
          validator:validateParentId,
          trigger: 'change'
        }]
      },
      systemList: [],
      choose: 3,
      data: [],
      treeProps: {
        label: 'name',
        children: 'child'
      },
      flag: false,
      name: null,
      id: null,
      hide:false,
      ids:null
    }
  },
  mounted() {

    if (this.sysId == '' || this.sysId == null || this.sysId == undefined) {
      this.getSystemList()
    } else {
      this.submitData.appId=this.sysId
      this.ids=this.parentId
      menuType({
        appId: this.sysId,
        menuType: 5
      }).then(res => {
        if (res && res.code == 0) {
          this.hide = res.data
        }
      })
      this.getSystemDetail(this.sysId)
      this.flag = true
      this.getPermissionsList(this.sysId)
    }
  },
  methods: {
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.choose == 3) {
            this.submitData.parentId = 0
          } else if (this.choose == 4) {
          
            this.submitData.parentId = this.ids
           
          } else if (this.choose == 5) {
            this.submitData.parentId = 0
          }
          this.submitData.menuType = this.choose
          createMenu(this.submitData).then(res => {
            if (res && res.code === 0) {
              this.$message({
                message: '提交成功',
                type: 'success'
              })
              this.$emit('returnResult',this.submitData.appId)
            } else {
              this.$message.error(res.message)
            }
          })
        } else {
          return false
        }
      })
    },
    cancel() {
      this.$emit('returnResult',null)
    },
    // 获取系统
    getSystemList() {
      getSystem({
        pageNo: 1,
        pageSize: 1000
      }).then(res => {
        if (res && res.code == 0) {
          this.systemList = res.data.items
        }
      })
    },
    radioChange() {
    
    },
    getPermissionsList(data) {
      permissionsList({
        appId: data
      }).then(res => {
        if (res && res.code == 0) {
          if(this.data.length>0){
            this.data=[]
          }
          for(var i=0;i<res.data.length;i++){
            if(res.data[i].menuType==3){
              this.data.push(res.data[i])
            }
          }
   
      
        }
      })
    },
    // 获取菜单
    getContents(data) {
     this.submitData.appId=data
     
      menuType({
        appId: data,
        menuType: 5
      }).then(res => {
        if (res && res.code == 0) {
          this.hide = res.data
        }
      })
      this.getPermissionsList(data)
    },
    handleNodeClick(data,that, isParent) {
      
        this.styleRender(that, isParent)
      this.submitData.parentId=data.id
      this.ids = data.id
    
    },
    // 获取系统详情
    getSystemDetail(data) {
      systemDetail({
        id: data
      }).then(res => {
        if (res && res.code == 0) {
          this.name = res.data.name
        }
      })
    },
    styleRender (that, isParent) {
      if (isParent) {
        jq("#custom-tree .option-group").animate({ height: '0px' }, 0.5)
        jq("#custom-tree .active-group").removeClass('active')
        jq("#custom-tree .el-tree-node__expand-icon").removeClass('expanded')
        jq(that.currentTarget).addClass('active')
        jq(that.currentTarget).children('.el-tree-node__expand-icon').addClass('expanded')
        jq(that.currentTarget).siblings('.option-group').animate({ height: '26px' }, 0.5)
      } else {
        jq("#custom-tree .option-group").removeClass('active-option')
        jq(that.currentTarget).addClass('active-option')
      }

      that.stopPropagation()
    },

  }
}
</script>
<style lang="scss" scoped>
.el-radio{
  margin-right:40px;
  width:40px;
}
.el-select{
  width:100%;
}
.title {
  width: 120px;
  text-align: right;
  font-size: 14px;
  padding-right: 13px;
  display: inline-block;
}
.el-radio {
  font-size: 14px !important;
  margin-right: 50px;
}
.el-tree {
  font-size: 12px;
}
.file {
  width: 16px;
  height: 16px;
  display: inline-block;
  background-size: contain;
  background-image: url("../../../../assets/icon.png");
  margin-right: 8px;
}
#custom-tree {
  width: 300px;
  font-size: 12px;
  color: #606266;
  line-height: 26px;
  background: #ffffff;
  cursor: pointer;
  /* margin-left:117px; */
  position: relative;
  top:0px;
  .file {
    width: 16px;
    height: 16px;
    display: inline-block;
    background-size: contain;
    margin-right: 8px;
    position: relative;
    top: 3px;
  }
  .icon-list {
    margin-left: 10px;
    display: none;
    i {
      margin-left: 10px;
    }
  }
  .title-group {
    display: inline-block;
  }
  .title-group .lable-text,
  .option-group .lable-text {
    width: 150px;
    display: inline-block;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
    margin-bottom: -9px;
  }
  .el-tree-node__expand-icon {
    cursor: pointer;
    font-size: 12px;
    transform: rotate(0deg);
    transition: transform 0.5s ease-in-out;
  }
  .expanded {
    transform: rotate(90deg);
  }
  .option-group {
    height: 0px;
    padding-left: 40px;
    overflow: hidden;
  }
  .active-group:hover,
  .option-group:hover {
    background: rgba($color: #ffa940, $alpha: 0.1);
    .icon-list {
      display: inline-block;
    }
  }
  .active {
    background: rgba($color: #ffa940, $alpha: 0.85);
    color: #ffffff;
    .el-tree-node__expand-icon {
      color: #ffffff;
    }
    .icon-list {
      display: inline-block;
    }
  }
  .active:hover {
    background: rgba($color: #ffa940, $alpha: 0.85);
  }
  .active-option {
    color: rgba($color: #ffa940, $alpha: 0.85);
    .icon-list {
      display: inline-block;
    }
  }
}
</style>
